<div #container class="content">
  <svg id="svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    <circle r="45" cx="50" cy="50" stroke-width="10" fill="transparent" stroke-dasharray="280" stroke-dashoffset="0"></circle>
    <circle [style]="getStyle()" id="bar" r="45" cx="50" cy="50" stroke-width="10" fill="transparent" stroke-dasharray="280" stroke-dashoffset="0"></circle>
  </svg>
  <p class="amount-text">
    {{amount}}
  </p>
</div>
